module.exports = __webpack_public_path__ + "img/samsung-galaxy-note8.4ced5a32.jpg";